module.exports = __webpack_public_path__ + "assets/img/sprite.88cc53f4.svg";